/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: LinkDataOriginField.tsx
 * Project: mle-client-n
 * Committed last: 2022/5/4 @ 1626
 * ---
 * Description:
 */

import { observer }              from 'mobx-react';
import { Editor }                from '../../../../store/observables/Editor';
import { Tab, Tabs }             from '@blueprintjs/core';
import { useState }              from 'react';
import { LinkBuiltinPanel }      from './LinkBuiltinPanel';
import { LinkDynamicPanel }      from './LinkDynamicPanel';
import { DataRefType, IDataRef } from '@revodigital/mpes';
import {
  dataRefNameOf
}                                from '@revodigital/mpes/lib/components/data/DataRefNameFactory';
import { MleToaster, Toasts }    from '../../../../common/toast';

interface Props {
  editor: Editor;
  closeOriginAdd: () => void;
  updateCellContent: (newContent: string) => void;
}

enum OriginTabs {
  DYNAMIC = 'dynamic',
  BUILTIN = 'builtin',
  DERIVED = 'derived'
}

export const LinkDataOriginField = observer((props: Props) => {
  const [ selectedTab, setSelectedTab ] = useState(OriginTabs.DYNAMIC);

  const handleApplyOrigin = (dataRef: IDataRef) => {
    if (dataRef.type !== DataRefType.BUILTIN)
      props.editor.dataOriginFeature.addDataRef(dataRef);

    MleToaster.getInstance().show(Toasts.DYNAMIC_FIELD_INSERTED);
    props.updateCellContent(dataRefNameOf(dataRef.name));
    props.closeOriginAdd();
  };

  return (
    <div style={ { width: '40em' } } className="ml-2 h-full">
      <div className="text-xl">Collega campo dinamico</div>
      <div className="h-64">
        <Tabs id="tabs" onChange={ (id) => {setSelectedTab(id as OriginTabs);} }
              selectedTabId={ selectedTab }>
          <Tab id={ OriginTabs.DYNAMIC } title="Campo dinamico"
               panel={ <LinkDynamicPanel editor={ props.editor }
                                         onDataOriginChange={ (ref) => {
                                           if (ref)
                                             handleApplyOrigin(ref);
                                         } }/> }/>
          <Tab id={ OriginTabs.BUILTIN } title="Builtin"
               panel={ <LinkBuiltinPanel editor={ props.editor }
                                         onDataOriginChange={ (ref) => {
                                           if (ref)
                                             handleApplyOrigin(ref);
                                         } }
               /> }/>
          <Tab id={ OriginTabs.DERIVED } title="Campo derivato" disabled></Tab>
        </Tabs>
      </div>
    </div>
  );
});
